import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, Tabs, Tab, ListGroup, InputGroup } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import ConfirmationModal from '../../common_components/ConfirmationModal';

const OfferDetailsModal = ({ show, handleClose, offer, token, fetchUpdatedOffer }) => {
    console.log('Received offer:', JSON.stringify(offer, null, 2));
    const [availableStores, setAvailableStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState(null);
    const [formValues, setFormValues] = useState({
        name: offer.name,
        description: offer.description,
        coupon_code: offer.coupon_code,
        discount: offer.discount,
        start_date: offer.start_date,
        end_date: offer.end_date,
        store_brand_name: offer.store_brand_name,
        status: offer.status,
    });

    const [storeToRemove, setStoreToRemove] = useState(null);

    const isEditable = offer?.is_owner;

    const [showConfirmationModal, setShowConfirmationModal] = useState({
        show: false,
        action: '',
    });


    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleSaveChanges = async () => {
        try {
            const payload = {
                ...formValues,
            };
            await axios.patch(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/grocery-offers/${offer.id}/`, payload, {
                headers: { Authorization: `Token ${token}` },
            });
            toast.success('Changes saved successfully!');
            fetchUpdatedOffer();
            handleClose();
        } catch (error) {
            toast.error('Failed to save changes. Could you please try again?');
            console.error('Failed to save changes', error);
        }
    };

    const handleDeleteOffer = async () => {
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/grocery-offers/${offer.id}/`, {
                headers: { Authorization: `Token ${token}` },
            });
            toast.success('Offer deleted successfully!');
            fetchUpdatedOffer();
            handleClose();
        } catch (error) {
            toast.error('Failed to delete offer. Could you please try again?');
            console.error('Failed to delete offer', error);
        }
    };

    const handleStoreSelectChange = (selectedOption) => {
        setSelectedStore(selectedOption);
    };

    const handleStoreInputChange = (inputValue) => {
        fetchAvailableStores(inputValue);
    };

    const fetchAvailableStores = async (searchTerm = '') => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/grocery-stores/`, {
                params: {
                    search: searchTerm,
                    brand_id: offer.brand,
                },
                headers: { Authorization: `Token ${token}` },
            });
            setAvailableStores(data.results);
        } catch (error) {
            console.error('Failed to fetch stores', error);
        }
    };

    const handleAddStore = async () => {
        if (!selectedStore) {
            alert("Please select a store");
            return;
        }

        try {
            const payload = {
                offer: offer.id,
                store: selectedStore.value,
            };
            await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/offer-stores/`, payload, {
                headers: { Authorization: `Token ${token}` },
            });
            // Fetch the updated offer
            toast.success('Store added successfully!');
            setSelectedStore(null);
        } catch (error) {
            console.error('Failed to add store', error.response.data);
            toast.error(error.response.data.store[0]);
        }
    };

    const handleRemoveStore = async () => {
        if (!storeToRemove) {
            alert("Please select a store");
            return;
        }
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_API_URL}/highgarden/offer-stores/${storeToRemove}/`, {
                headers: { Authorization: `Token ${token}` },
            });
            toast.success('Store removed successfully!');
            setStoreToRemove(null);
            fetchUpdatedOffer(); // Optionally fetch updated offer data
        } catch (error) {
            toast.error('Failed to remove store. Could you please try again?');
            console.error('Failed to remove store', error);
        } finally {
            setShowConfirmationModal({ show: false, action: '' });
        }
    };


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Body>
                <Tabs defaultActiveKey="basic" id="offer-details" className="mb-3">
                    <Tab eventKey="basic" title={`Basic Details`}>
                        <Form>
                            <Row>
                                <Form.Group controlId="formOfferName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter offer name"
                                        name="name"
                                        value={formValues.name}
                                        onChange={handleFormChange}
                                        disabled={!isEditable}
                                    />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group controlId="formOfferDescription">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Enter offer description"
                                        name="description"
                                        value={formValues.description}
                                        onChange={handleFormChange}
                                        disabled={!isEditable}
                                    />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group controlId="formCouponCode">
                                    <Form.Label>Coupon Code</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter coupon code"
                                        name="coupon_code"
                                        value={formValues.coupon_code}
                                        onChange={handleFormChange}
                                        disabled={!isEditable}
                                    />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group controlId="formDiscount">
                                    <Form.Label>Discount</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter discount"
                                        name="discount"
                                        value={formValues.discount}
                                        onChange={handleFormChange}
                                        disabled={!isEditable}
                                    />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group controlId="formStartDate">
                                        <Form.Label>Start Date</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="start_date"
                                            value={formValues.start_date}
                                            onChange={handleFormChange}
                                            disabled={!isEditable}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="formEndDate">
                                        <Form.Label>End Date</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="end_date"
                                            value={formValues.end_date}
                                            onChange={handleFormChange}
                                            disabled={!isEditable}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Form.Group controlId="formStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        name="status"
                                        value={formValues.status}
                                        onChange={handleFormChange}
                                        disabled={!isEditable}
                                    >
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">Inactive</option>
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Tab>
                    <Tab eventKey="stores" title={`Stores`}>
                        {offer.is_owner && (
                            <Form.Group controlId="formProductSelect">
                                <Row className="align-items-center">
                                    <Col md={10}>
                                        <InputGroup>
                                            <InputGroup.Text>{offer.store_brand_name}</InputGroup.Text>
                                            <div style={{ flexGrow: 1 }}>
                                                <Select
                                                    options={availableStores.map(store => ({
                                                        value: store.id,
                                                        label: store.name,
                                                    }))}
                                                    onChange={handleStoreSelectChange}
                                                    onInputChange={handleStoreInputChange}
                                                    value={selectedStore}
                                                    style={{ width: '100%' }}
                                                />
                                            </div>
                                        </InputGroup>
                                    </Col>
                                    <Col md={2} className="d-flex justify-content-center">  {/* Adjusted to 2 and centered */}
                                        <Button variant="success" onClick={handleAddStore} style={{ padding: '5px 10px' }}>  {/* Adjusted button padding */}
                                            <i className="bi bi-plus-lg"></i>
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Group>
                        )}
                        <Row>
                            <Col>
                                <ListGroup className='mt-3' style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                    {offer.stores.map((store) => (
                                        <ListGroup.Item key={store.through_id} className="d-flex align-items-center">
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="d-flex align-items-center">
                                                    {offer.is_owner && (
                                                        <i
                                                            className="bi bi-dash-circle"
                                                            style={{ cursor: 'pointer', marginRight: '10px' }}
                                                            onClick={() => {
                                                                setStoreToRemove(store.through_id);
                                                                setShowConfirmationModal({
                                                                    show: true,
                                                                    action: 'removeStore',
                                                                });
                                                            }}
                                                        ></i>
                                                    )}
                                                    <h6 className="mb-0">{store.store_name}</h6> {/* Ensure there’s no margin */}
                                                </div>
                                            </div>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            </Col>
                        </Row>

                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                {isEditable && (
                    <Button
                        variant="danger"
                        onClick={() => setShowConfirmationModal({ show: true, action: 'deleteOffer' })}
                    >
                        Delete Offer
                    </Button>
                )}
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                {isEditable && (
                    <Button variant="primary" onClick={handleSaveChanges}>
                        Save Changes
                    </Button>
                )}
            </Modal.Footer>
            <ConfirmationModal
                show={showConfirmationModal.show}
                title={showConfirmationModal.action === 'removeStore' ? "Remove Store" : "Delete Offer"}
                body={
                    showConfirmationModal.action === 'removeStore'
                        ? "Are you sure you want to remove this store from the offer?"
                        : "Are you sure you want to delete this offer?"
                }
                onConfirm={
                    showConfirmationModal.action === 'removeStore'
                        ? handleRemoveStore
                        : handleDeleteOffer
                }
                onHide={() => setShowConfirmationModal({ show: false, action: '' })}
            />
        </Modal >
    );
};

export default OfferDetailsModal;
